// @ts-nocheck
import { defineComponent, h, inject } from 'vue'
import { useNamespace } from '@jdesign-vue/hooks'
import { CASCADER_PANEL_INJECTION_KEY } from './types'

export default defineComponent({
  name: 'NodeContent',
  props: {
    node: {
      type: Object,
      required: true,
    },
    panel: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const ns = useNamespace('cascader-node')
    return {
      ns,
    }
  },
  render() {
    const { ns } = this
    const { node, panel } = this.$props
    const { data, label } = node
    const { renderLabelFn } = panel

    // 获取面板上下文以判断单选模式
    const panelContext = inject(CASCADER_PANEL_INJECTION_KEY)
    const isMultiple = panelContext?.config?.multiple

    // 获取是否启用文本换行
    const wrapText = panelContext?.config?.wrapText || false

    // 判断节点是否被选中
    // 多选模式：使用node.checked或node.indeterminate
    // 单选模式：检查当前节点是否在选中节点的路径中（包括父级节点）
    let isSelected = false
    if (isMultiple) {
      isSelected = node.checked || node.indeterminate
    } else {
      // 单选模式：检查当前节点是否在选中节点的路径中
      const checkedNodes = panelContext?.checkedNodes || []
      if (checkedNodes.length > 0) {
        // 获取第一个选中节点的完整路径
        const selectedNode = checkedNodes[0]
        // 检查当前节点是否在选中节点的路径中
        isSelected = selectedNode.pathNodes.some(
          (pathNode: any) => pathNode.uid === node.uid
        )
      }
      // 如果checkedNodes为空，但node.checked为true，也认为选中
      if (!isSelected && node.checked) {
        isSelected = true
      }
    }

    return h(
      'span',
      {
        class: [
          ns.e('label'),
          {
            [ns.is('selected')]: isSelected,
            [ns.is('wrap-text')]: wrapText,
          },
        ],
        title: label,
        // style: wrapText
        //   ? {
        //       whiteSpace: 'normal',
        //       wordBreak: 'break-all',
        //     }
        //   : {},
      },
      renderLabelFn ? renderLabelFn({ node, data }) : label
    )
  },
})
